'use strict';

const location = function (countries) {
  return function (value) {
    var formattedValue = value && value.name;
    var countryCode = value && value.countryCode;

    if (formattedValue && countryCode) {
      formattedValue += ', ' + countries[countryCode].name;
    }

    return formattedValue;
  };
};

location.$inject = [
  'countries'
];

export default location;



// WEBPACK FOOTER //
// ./app/src/filters/location.js